// This file creates wrapped versions of component library components
// that correctly inherit the Vuetify instance from the host application
/* eslint-disable */
import Vue from 'vue'
import {
  SystemList as OriginalSystemList,
  SystemCard as OriginalSystemCard,
  IntegrationCard as OriginalIntegrationCard,
  StepperAccordion as OriginalStepperAccordion,
  JsonEditor as OriginalJsonEditor,
  QuestionCard as OriginalQuestionCard,
  QuestionGroup as OriginalQuestionGroup,
  SelectorCard as OriginalSelectorCard,
  SlidingSheet as OriginalSlidingSheet,
  FileLoaderTable as OriginalFileLoaderTable,
  FileLoaderTableView as OriginalFileLoaderTableView,
  FileLoaderGroupedList as OriginalFileLoaderGroupedList,
  MetricCard as OriginalMetricCard,
  StatusBadge as OriginalStatusBadge
} from '@syrenis/cassie-material-design'
import vuetify from '../plugins/vuetify.js'

// Create wrapped components that explicitly include the Vuetify instance
export const SystemList = Vue.extend({
  name: 'system-list-wrapper',
  extends: OriginalSystemList,
  vuetify // Pass the Vuetify instance explicitly
})

export const SystemCard = Vue.extend({
  name: 'system-card-wrapper',
  extends: OriginalSystemCard,
  vuetify
})

export const IntegrationCard = Vue.extend({
  name: 'integration-card-wrapper',
  extends: OriginalIntegrationCard,
  vuetify
})


export const StepperAccordion = Vue.extend({
  name: 'stepper-accordion-wrapper',
  extends: OriginalStepperAccordion,
  vuetify
})

// Legacy export for backward compatibility
export const StepperAccordionVStepper = StepperAccordion

export const JsonEditor = Vue.extend({
  name: 'json-editor-wrapper',
  extends: OriginalJsonEditor,
  vuetify
})

export const QuestionCard = Vue.extend({
  name: 'question-card-wrapper',
  extends: OriginalQuestionCard,
  vuetify
})

export const QuestionGroup = Vue.extend({
  name: 'question-group-wrapper',
  extends: OriginalQuestionGroup,
  vuetify
})

export const SelectorCard = Vue.extend({
  name: 'selector-card-wrapper',
  extends: OriginalSelectorCard,
  vuetify
})

export const SlidingSheet = Vue.extend({
  name: 'sliding-sheet-wrapper',
  extends: OriginalSlidingSheet,
  vuetify
})

export const FileLoaderTable = Vue.extend({
  name: 'file-loader-table-wrapper',
  extends: OriginalFileLoaderTable,
  vuetify
})

export const FileLoaderTableView = Vue.extend({
  name: 'file-loader-table-view-wrapper',
  extends: OriginalFileLoaderTableView,
  vuetify
})

export const FileLoaderGroupedList = Vue.extend({
  name: 'file-loader-grouped-list-wrapper',
  extends: OriginalFileLoaderGroupedList,
  vuetify
})

export const MetricCard = Vue.extend({
  name: 'metric-card-wrapper',
  extends: OriginalMetricCard,
  vuetify
})

export const StatusBadge = Vue.extend({
  name: 'status-badge-wrapper',
  extends: OriginalStatusBadge,
  vuetify
})
